import React from "react";
import { MapPin, TrainFront, Bus, CarTaxiFront, CircleParking } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function WhereWeBloom() {
  const address = "Serving Clarksville, Nashville, Fort Campbell, Hopkinsville, Middle Tennessee, and Southern Kentucky.";
  const transportLinks = [{
    id: "metro-1",
    icon: TrainFront,
    text: "Clarksville & Fort Campbell",
    distance: "Local"
  }, {
    id: "bus-1",
    icon: Bus,
    text: "Nashville & Middle Tennessee",
    distance: "Regional"
  }];
  const actionLinks = [{
    id: "taxi-1",
    icon: CarTaxiFront,
    text: "Inquire About Your Event",
    to: "/ContactPage"
  }, {
    id: "parking-1",
    icon: CircleParking,
    text: "View Our Packages",
    to: "/PackagesPage"
  }];
  return <section data-section-id="256665" id="where-we-bloom" className="bg-background py-6 px-4 md:px-6 border-b border-secondary/20">
      <div className="max-w-3xl mx-auto flex flex-col gap-6">
        {}
        <div className="flex items-start gap-3">
          <MapPin className="lucide lucide-map-pin w-5 h-5 shrink-0 mt-0.5 text-primary" aria-hidden="true" />
          <h2 className="text-sm md:text-base font-default text-foreground leading-snug tracking-wide">
            {address}
          </h2>
        </div>

        {}
        <div className="flex flex-col gap-4 pl-8">
          {transportLinks.map((link, i) => <div key={link.id} data-index={i} className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <link.icon className="w-5 h-5 text-primary shrink-0" aria-hidden="true" />
                <span className="text-sm font-default text-foreground/90">{link.text}</span>
              </div>
              <span className="text-xs font-default uppercase tracking-widest whitespace-nowrap text-primary">
                {link.distance}
              </span>
            </div>)}
        </div>

        {}
        <div className="flex flex-col gap-4 pl-8 mt-2">
          {actionLinks.map((link, i) => <div key={link.id} data-index={i}>
              <Link to={link.to} className="inline-flex items-center gap-3 text-primary hover:text-secondary transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md">
                <link.icon className="w-5 h-5 shrink-0" aria-hidden="true" />
                <span className="text-sm font-default font-medium uppercase tracking-wider">{link.text}</span>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}